import { Category } from "@type/categories";
import ProductItem from "../ProductItem/ProductItem";
import styles from "./ProductGrid.module.scss";
import { useAppContext } from "@context/appContext";
import AmountModal from "@components/AmountModal/AmountModal";
import { useState } from "react";
import { Product } from "@type/products";

const ProductGrid = () => {
  const { products, categories, activeCategory, add } = useAppContext();
  const [showAmountModal, setShowAmountModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  if (!products) return <div>No products</div>;

  const filteredProducts = activeCategory
    ? products.filter((product) => product.category === activeCategory)
    : products;

  const handleOpenModal = (product: Product) => {
    setSelectedProduct(product);
    setShowAmountModal(true);
  };

  const handleConfirmHold = (product: Product, amount: number) => {
    if (amount > 0) {
      for (let i = 0; i < amount; i++) {
        add(product.uid);
      }
    }
    setShowAmountModal(false);
    setSelectedProduct(null);
  };

  return (
    <div>
      <ul className={styles.productGrid}>
        {filteredProducts.map((product) => (
          <ProductItem
            key={product.uid}
            product={product}
            category={
              categories?.find(
                (category) => category.name === product.category
              ) || ({ color: "#068cfc", name: "" } as Category)
            }
            onHold={handleOpenModal}
          />
        ))}
      </ul>
      <AmountModal
        showModal={showAmountModal}
        setShowModal={setShowAmountModal}
        product={selectedProduct}
        onConfirm={handleConfirmHold}
      />
    </div>
  );
};

export default ProductGrid;
